import { render } from "./DealerTable.vue?vue&type=template&id=5eb0f929&scoped=true"
import script from "./DealerTable.vue?vue&type=script&lang=js"
export * from "./DealerTable.vue?vue&type=script&lang=js"

import "./DealerTable.vue?vue&type=style&index=0&id=5eb0f929&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eb0f929"]])

export default __exports__